import { findIndex } from 'lodash';
import {
  getCompanyDataAction,
  getCompanySeasonsValueAction,
  getCompanyVenuesAction,
  getCompanyUnpublishedSeasonAction,
  getCompanyContactAction,
  updateCompanyAction,
  getMusicalWorksListAction,
  getCompanyEditSeasonAction,
  getCompanyImagesAction,
  getCompanyVideosAction,
  getCompanyStaffAction,
  getCompanyDescriptionsAction,
  createCompanyDescriptionAction,
  updateCompanyDescriptionAction,
  deleteCompanyDescriptionAction,
  updateCompanyVideoAction,
  addCompanyVideoAction,
  getCompanyProductionsAction,
  getCompanyEmployeesAction,
  getCompanyBannerImagesAction,
  getCompanyLsVodAction,
  getCompanyProductionVideosAction,
  getCompanyProductionImagesAction,
  getCompanySearchProductionsAction,
  getCompanyTranslationsAction,
  deleteCompanyTranslationsAction,
  getCompanyYoungArtistProgramAction,
  deleteCompanyYoungArtistProgramAction,
  createCompanyYoungArtistProgramAction,
  getCompanyFestivalsAction,
  createCompanyFestivalAction,
  deleteCompanyFestivalAction,
  getAboutCompanyVideoAction,
  getCompanyReviewsAction,
  getCompanyProductionReviewsAction,
} from './actions';
import {
  listReducer,
  defaultListParams,
  entityReducer,
  defaultEntityParams,
  namedListParams,
} from '../../utils/crudUtils';
import { CLEAR_EDIT_SEASONS, DELETE_COMPANY_VIDEO, SET_COMPANY, SET_SEASONS } from './constants';
import { changeItemInObjectsArray } from '../../utils/editCommon';

export const key = 'Company';

export const initialState = {
  companyData: defaultEntityParams,
  editSeasonProductions: defaultListParams,
  unpublishedProductions: defaultListParams,
  venues: namedListParams('venues'),
  seasons: defaultListParams,
  error: null,
  musicalWorksList: defaultListParams,
  images: namedListParams('images'),
  productionImages: namedListParams('productionImages'),
  videos: namedListParams('videos'),
  productionVideos: namedListParams('productionVideos'),
  lsVod: namedListParams('lsVod'),
  searchProductions: namedListParams('searchProductions'),
  staff: namedListParams('staff'),
  isStaffUpdating: false,
  staffSuggestions: namedListParams('staffSuggestions'),
  descriptions: namedListParams('descriptions'),
  productions: namedListParams('productions'),
  employees: namedListParams('employees'),
  banner: namedListParams('banner'),
  aboutCompanyVideo: namedListParams('aboutCompanyVideo'),
  reviews: namedListParams('reviews'),
  productionReviews: namedListParams('productionReviews'),
};

const companyReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case getCompanyDataAction.TRIGGER:
    case getCompanyDataAction.SUCCESS:
    case getCompanyDataAction.FAILURE:
      return entityReducer(state, type, payload, 'companyData');

    case getCompanyContactAction.TRIGGER:
    case getCompanyContactAction.SUCCESS:
    case getCompanyContactAction.FAILURE:
      return listReducer(
        state,
        type,
        payload.data
          ? { ...payload, data: payload.data.map(el => ({ ...el, name: el?.name?.toLowerCase() })) }
          : payload,
        'contacts',
      );

    case getCompanyEditSeasonAction.TRIGGER:
    case getCompanyEditSeasonAction.SUCCESS:
    case getCompanyEditSeasonAction.FAILURE:
      return listReducer(state, type, payload, 'editSeasonProductions');

    case getCompanyUnpublishedSeasonAction.TRIGGER:
    case getCompanyUnpublishedSeasonAction.SUCCESS:
    case getCompanyUnpublishedSeasonAction.FAILURE:
      return listReducer(state, type, payload, 'unpublishedProductions');

    case getCompanySeasonsValueAction.TRIGGER:
    case getCompanySeasonsValueAction.SUCCESS:
    case getCompanySeasonsValueAction.FAILURE:
      return listReducer(state, type, payload, 'seasons');

    case SET_SEASONS:
      return { ...state, seasons: payload.seasons };

    case getCompanyVenuesAction.TRIGGER:
    case getCompanyVenuesAction.SUCCESS:
    case getCompanyVenuesAction.FAILURE:
      return listReducer(state, type, payload, initialState.venues.listName);

    case updateCompanyAction.TRIGGER:
    case updateCompanyAction.SUCCESS:
    case updateCompanyAction.FAILURE:
      return entityReducer(state, type, payload, 'companyData');

    case SET_COMPANY:
      return { ...state, companyData: { ...state.companyData, entity: payload } };

    case CLEAR_EDIT_SEASONS:
      return { ...state, editSeasonProductions: { ...state.editSeasonProductions, data: [] } };

    case getMusicalWorksListAction.TRIGGER:
    case getMusicalWorksListAction.SUCCESS:
    case getMusicalWorksListAction.FAILURE:
      return listReducer(state, type, payload, 'musicalWorksList');

    case getCompanyImagesAction.FAILURE:
    case getCompanyImagesAction.TRIGGER:
    case getCompanyImagesAction.SUCCESS:
      return listReducer(state, type, payload, initialState.images.listName);

    case getCompanyProductionImagesAction.FAILURE:
    case getCompanyProductionImagesAction.TRIGGER:
    case getCompanyProductionImagesAction.SUCCESS:
      return listReducer(state, type, payload, initialState.productionImages.listName);

    case getCompanyBannerImagesAction.FAILURE:
    case getCompanyBannerImagesAction.TRIGGER:
    case getCompanyBannerImagesAction.SUCCESS:
      return listReducer(state, type, payload, initialState.banner.listName);

    case getCompanyVideosAction.FAILURE:
    case getCompanyVideosAction.TRIGGER:
    case getCompanyVideosAction.SUCCESS:
      return listReducer(state, type, payload, initialState.videos.listName);

    case getCompanyProductionVideosAction.FAILURE:
    case getCompanyProductionVideosAction.TRIGGER:
    case getCompanyProductionVideosAction.SUCCESS:
      return listReducer(state, type, payload, initialState.productionVideos.listName);

    case getCompanyLsVodAction.FAILURE:
    case getCompanyLsVodAction.TRIGGER:
    case getCompanyLsVodAction.SUCCESS:
      return listReducer(state, type, payload, initialState.lsVod.listName);

    case getCompanyStaffAction.FAILURE:
    case getCompanyStaffAction.TRIGGER:
    case getCompanyStaffAction.SUCCESS:
      return listReducer(state, type, payload, initialState.staff.listName);

    case getCompanyDescriptionsAction.TRIGGER:
    case getCompanyDescriptionsAction.SUCCESS:
    case getCompanyDescriptionsAction.FAILURE:
      return listReducer(state, type, payload, 'descriptions');

    case getCompanySearchProductionsAction.FAILURE:
    case getCompanySearchProductionsAction.TRIGGER:
    case getCompanySearchProductionsAction.SUCCESS:
      return listReducer(state, type, payload, 'searchProductions');

    case createCompanyDescriptionAction.SUCCESS:
      return { ...state, descriptions: { ...state.descriptions, data: [...state.descriptions.data, payload.entity] } };

    case updateCompanyDescriptionAction.SUCCESS: {
      const descriptions = [...state?.descriptions?.data];
      const updatedDescriptionIndex = findIndex(state?.descriptions?.data, { id: payload?.entity?.id });
      descriptions.splice(updatedDescriptionIndex, 1, payload?.entity);
      return { ...state, descriptions: { ...state.descriptions, data: descriptions } };
    }

    case deleteCompanyDescriptionAction.TRIGGER:
      return { ...state, descriptions: { ...state.descriptions, loading: true } };
    case deleteCompanyDescriptionAction.SUCCESS: {
      return {
        ...state,
        descriptions: {
          ...state.descriptions,
          data: state.descriptions.data.filter(d => d?.id !== payload?.id),
          loading: false,
        },
      };
    }
    case deleteCompanyDescriptionAction.FAILURE:
      return { ...state, descriptions: { ...state.descriptions, loading: false } };

    case updateCompanyVideoAction.TRIGGER:
      return { ...state, mediaUpdating: true };
    case updateCompanyVideoAction.SUCCESS: {
      return {
        ...state,
        [state.videos.listName]: {
          ...state[state.videos.listName],
          data: changeItemInObjectsArray(state[state.videos.listName]?.data, payload?.entity),
        },
        mediaUpdating: false,
      };
    }
    case updateCompanyVideoAction.FAILURE:
      return { ...state, mediaUpdating: false };

    case addCompanyVideoAction.TRIGGER:
      return { ...state, mediaUpdating: true };
    case addCompanyVideoAction.SUCCESS: {
      return {
        ...state,
        videos: { ...state.videos, data: [...state.videos.data, payload?.entity] },
        mediaUpdating: false,
      };
    }
    case addCompanyVideoAction.FAILURE:
      return { ...state, mediaUpdating: false };

    case DELETE_COMPANY_VIDEO:
      return { ...state, videos: { ...state.videos, data: state.videos.data.filter(i => i?.id !== payload?.id) } };

    case getCompanyProductionsAction.FAILURE:
    case getCompanyProductionsAction.TRIGGER:
    case getCompanyProductionsAction.SUCCESS:
      return listReducer(state, type, payload, state.productions.listName);

    case getCompanyEmployeesAction.FAILURE:
    case getCompanyEmployeesAction.TRIGGER:
    case getCompanyEmployeesAction.SUCCESS:
      return listReducer(state, type, payload, state.employees.listName);
    case getCompanyTranslationsAction.TRIGGER:
    case getCompanyTranslationsAction.SUCCESS:
    case getCompanyTranslationsAction.FAILURE:
      return listReducer(state, type, payload, 'translations');
    case deleteCompanyTranslationsAction.TRIGGER:
    case deleteCompanyTranslationsAction.FAILURE:
      return { ...state, festivals: { ...state.translations, loading: true } };
    case deleteCompanyTranslationsAction.SUCCESS: {
      return {
        ...state,
        translations: {
          ...state.translations,
          data: state.translations.data.filter(d => d?.id !== payload?.id),
          loading: false,
        },
      };
    }
    case getCompanyYoungArtistProgramAction.TRIGGER:
    case getCompanyYoungArtistProgramAction.SUCCESS:
    case getCompanyYoungArtistProgramAction.FAILURE:
      return listReducer(state, type, payload, 'youngArtistProgram');
    case deleteCompanyYoungArtistProgramAction.TRIGGER:
    case deleteCompanyYoungArtistProgramAction.FAILURE:
      return { ...state, youngArtistProgram: { ...state.youngArtistProgram, loading: true } };
    case deleteCompanyYoungArtistProgramAction.SUCCESS: {
      return {
        ...state,
        youngArtistProgram: {
          ...state.youngArtistProgram,
          data: state.youngArtistProgram.data.filter(d => d?.id !== payload?.id),
          loading: false,
        },
      };
    }
    case createCompanyYoungArtistProgramAction.SUCCESS:
      return {
        ...state,
        youngArtistProgram: { ...state.youngArtistProgram, data: [...state.youngArtistProgram.data, payload.entity] },
      };
    case getCompanyFestivalsAction.TRIGGER:
    case getCompanyFestivalsAction.SUCCESS:
    case getCompanyFestivalsAction.FAILURE:
      return listReducer(state, type, payload, 'festivals');
    case deleteCompanyFestivalAction.TRIGGER:
    case deleteCompanyFestivalAction.FAILURE:
      return { ...state, festivals: { ...state.festivals, loading: true } };
    case deleteCompanyFestivalAction.SUCCESS: {
      return {
        ...state,
        festivals: {
          ...state.festivals,
          data: state.festivals.data.filter(d => d?.id !== payload?.id),
          loading: false,
        },
      };
    }
    case createCompanyFestivalAction.SUCCESS:
      return {
        ...state,
        festivals: { ...state.festivals, data: [...state.festivals.data, payload.entity] },
      };
    case getAboutCompanyVideoAction.TRIGGER:
    case getAboutCompanyVideoAction.SUCCESS:
    case getAboutCompanyVideoAction.FAILURE:
      return listReducer(state, type, payload, 'aboutCompanyVideo');
    case getCompanyReviewsAction.TRIGGER:
    case getCompanyReviewsAction.SUCCESS:
    case getCompanyReviewsAction.FAILURE:
      return listReducer(state, type, payload, state?.reviews?.listName);

    case getCompanyProductionReviewsAction.TRIGGER:
    case getCompanyProductionReviewsAction.SUCCESS:
    case getCompanyProductionReviewsAction.FAILURE:
      return listReducer(state, type, payload, state?.productionReviews?.listName);
    default:
      return state;
  }
};

export default companyReducer;
